import { render, staticRenderFns } from "./notarizzazione.vue?vue&type=template&id=5e3f568c&"
import script from "./notarizzazione.vue?vue&type=script&lang=js&"
export * from "./notarizzazione.vue?vue&type=script&lang=js&"
import style0 from "./notarizzazione.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports